import { render, staticRenderFns } from "./HomeMailingList.vue?vue&type=template&id=5478f9f8&scoped=true&"
import script from "./HomeMailingList.vue?vue&type=script&lang=js&"
export * from "./HomeMailingList.vue?vue&type=script&lang=js&"
import style0 from "./HomeMailingList.vue?vue&type=style&index=0&id=5478f9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478f9f8",
  null
  
)

export default component.exports